var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v(_vm._s(_vm.vendor.name))]),_c('AdminBreadcrumbs',{attrs:{"vendor":_vm.vendor,"tail-text":"Ordre"}}),_c('v-card',{staticClass:"orange lighten-5",attrs:{"elevation":"3"}},[_c('v-card-title',{staticClass:"white--text orange"},[_vm._v(" Ordre "),_c('v-spacer'),_c('v-text-field',{attrs:{"append-icon":"mdi-magnify","label":"Søk","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.orders,"search":_vm.search},scopedSlots:_vm._u([{key:"item.ordered_at",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
            name: 'adminOrderDetail',
            params: {
              vendorId: _vm.vendor.id.toString(),
              orderId: item.id.toString(),
            },
          }}},[_vm._v(" "+_vm._s(item.ordered_at.toLocaleDateString())+" ")])]}},{key:"item.paid",fn:function(ref){
          var item = ref.item;
return [_c('OrderPaid',{attrs:{"paid":item.paid}})]}},{key:"item.delivered",fn:function(ref){
          var item = ref.item;
return [_c('OrderDelivered',{attrs:{"delivered":item.delivered}})]}},{key:"item.payment",fn:function(ref){
          var item = ref.item;
return [_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(item.payment))])]}},{key:"item.payment_status",fn:function(ref){
          var item = ref.item;
return [_c('PaymentStatus',{attrs:{"order":item}})]}},{key:"item.total",fn:function(ref){
          var item = ref.item;
return [_vm._v(" kr "+_vm._s(item.total)+",- ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }